import apolloClient from './../apolloClient.js'

const state = {
  comments: null,
  loading: false
}

const mutations = {
  SET_COMMENTS (state, comments) {
    state.comments = []
    comments.forEach((comment) => {
      state.comments.push(Object.assign({}, comment))
    })
  },
  ADD_COMMENT (state, comment) {
    state.comments.push(comment)
  },
  SET_VIEWED_COMMENTS (state) {
    state.comments.forEach((item, i) => {
      state.comments[i].isViewed = true
    })
  },
  CLEAR_COMMENTS (state) {
    state.comments = null
  },
  SET_COMMENTS_LOADING (state, value) {
    state.loading = value
  }
}

import getCommentsQuery from './../gql/queries/getComments.graphql'
import sendCommentMutation from './../gql/mutations/AddComment.graphql'
import markAsViewedCommentMutation from './../gql/mutations/MarkAsViewedComments.graphql'

const actions = {
  /**
   * Получить список комментариев к заказу
   * @param commit
   * @param orderId
   */
  getComments: ({commit, dispatch}, orderId) => {
    commit('SET_COMMENTS_LOADING', true)
    commit('CLEAR_COMMENTS')
    apolloClient.query({
      query: getCommentsQuery,
      variables: {
        orderId: orderId
      },
      fetchPolicy: 'network-only'
    }).then((result) => {
      commit('SET_COMMENTS', result.data.comments)
      commit('SET_COMMENTS_LOADING', false)
      setTimeout(() => {
        dispatch('markAsViewed', orderId)
      }, 2000)
    }).catch((error) => {
      console.log(error)
      commit('SET_COMMENTS_LOADING', false)
    })
  },
  markAsViewed ({commit}, orderId) {
    apolloClient.mutate({
      mutation: markAsViewedCommentMutation,
      variables: {
        orderId: orderId
      }
    }).then((result) => {
      commit('SET_VIEWED_COMMENTS')
      commit('COMMENTS_HAS_BEEN_VIEWED', orderId)
    }).catch((error) => {
      console.log(error)
    })
  },
  sendComment: ({commit}, params) => {
    return new Promise((resolve, reject) => {
      apolloClient.mutate({
        mutation: sendCommentMutation,
        variables: {
          text: params.text,
          orderId: params.orderId
        }
      }).then((result) => {
        commit('ADD_COMMENT', result.data.addComment)
        commit('COMMENT_HAS_BEEN_ADDED', result.data.addComment)
        resolve()
      }).catch((error) => {
        reject(error)
      })
    })
  }
}

export default {
  state, mutations, actions
}



// WEBPACK FOOTER //
// ./src/store/commentStore.js